<div class="modal" [ngClass]="{ 'is-active': showMessageBox }">
  <div class="modal-background"></div>
  <div class="modal-content">
    <div class="card">
      <div class="card-content">
        <p class="title">{{ messageBoxElements.title }}</p>
        <p class="vhq-message-box-message">
          {{ messageBoxConfig?.message }}
        </p>
        <br />
        <div class="level">
          <div class="level-left">
            <button
              *ngIf="messageBoxElements.cancelButton.isVisible"
              class="level-left button is-text has-text-primary"
              (click)="cancelMessageBox()"
            >
              Cancel
            </button>
          </div>
          <div class="buttons">
            <button
              *ngIf="messageBoxElements.declineButton.isVisible"
              class="button is-outlined"
              [ngClass]="messageBoxElements.declineButton.style"
              (click)="declineMessageBox()"
            >
              {{ messageBoxElements.declineButton.title }}
            </button>
            <button
              class="button"
              [ngClass]="messageBoxElements.affirmationButton.style"
              (click)="affirmativeMessageBox()"
            >
              {{ messageBoxElements.affirmationButton.title }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
